customElements.whenDefined('facet-filters-form').then(() => {
  const root = document.querySelector('[data-senshen-stock-collection]');
  if (!root || root.dataset.stockSupported !== 'true') return;

  const params = new URLSearchParams(window.location.search);
  const curated = root.dataset.stockCurated === 'true';
  if (curated ? !params.has('filter.v.availability') : !root.hasAttribute('data-stock-pending')) return;
  if (curated) params.delete('filter.v.availability');
  else params.set('filter.v.availability', '1');
  const searchParams = params.toString();
  const notice = root.querySelector('[data-stock-notice]');
  const fallback = notice.querySelector('a');
  fallback.href = `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}${window.location.hash}`;

  FacetFiltersForm.renderPage(searchParams, null, false)
    .then(() => {
      history.replaceState({ searchParams }, '', fallback.href);
      FacetFiltersForm.searchParamsInitial = searchParams;
      root.removeAttribute('data-stock-pending');
      notice.hidden = true;
    })
    .catch(() => {
      notice.querySelector('[role="status"]').textContent = fallback.textContent;
    });
});
